export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14705.c47d1a05.jpg";